import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createSupportReportSlice = (set, get) => ({
    support: {
        loading: false,
        data: [],
        filtered: []
    },
    getSupport: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ support: { ...state.support, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: "post",
                baseURL: config.apiUrls(),
                url: "/v1/business/support-detail-report",
                headers: { token }
            });
            set(state => ({ support: { loading: false, data: resp.data, filtered: resp.data } }));
        } catch (error) {
            set(state => ({ support: { ...state.support, loading: false } }));
        }
    },
    filterSupport: (value) => {
        const data = get().support.data;
        const filtered = data.filter((item) => {
            // Implement filter logic here
        });
        set(state => ({ support: { ...state.support, filtered } }));
    }
});
